<script>
  import { useForm } from '@inertiajs/svelte';

  export let error = null;

  const form = useForm({ email: '', password: '' });

  function submit() {
    $form.post('/login');
  }
</script>

<svelte:head>
  <title>Sign In — Age of Trevor Webedit</title>
</svelte:head>

<div class="login-wrap">
  <div class="login-card">
    <div class="login-header">
      <h1>Age of Trevor</h1>
      <p>Webedit — sign in to continue</p>
    </div>

    {#if error || $form.errors.email || $form.errors.password}
      <div class="error-banner">
        {error || $form.errors.email || $form.errors.password}
      </div>
    {/if}

    <form on:submit|preventDefault={submit} class="login-form">
      <div class="field">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          bind:value={$form.email}
          autocomplete="email"
          placeholder="you@example.com"
          disabled={$form.processing}
        />
      </div>

      <div class="field">
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          bind:value={$form.password}
          autocomplete="current-password"
          placeholder="••••••••"
          disabled={$form.processing}
        />
      </div>

      <button type="submit" class="btn-submit" disabled={$form.processing}>
        {$form.processing ? 'Signing in…' : 'Sign in'}
      </button>
    </form>
  </div>
</div>

<style>
  .login-wrap {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%);
    padding: 2rem;
  }

  .login-card {
    background: white;
    border-radius: 1rem;
    padding: 2.5rem;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
  }

  .login-header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .login-header h1 {
    font-size: 1.75rem;
    font-weight: 800;
    color: #1e3a8a;
    margin: 0 0 0.25rem 0;
  }

  .login-header p {
    color: #64748b;
    margin: 0;
    font-size: 0.9rem;
  }

  .error-banner {
    background: #fef2f2;
    border: 1px solid #fca5a5;
    color: #dc2626;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
  }

  .login-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
  }

  label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
  }

  input {
    padding: 0.625rem 0.875rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }

  input:disabled {
    background: #f9fafb;
    color: #9ca3af;
  }

  .btn-submit {
    background: linear-gradient(135deg, #1d4ed8, #3b82f6);
    color: white;
    border: none;
    padding: 0.75rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.2s;
    margin-top: 0.5rem;
  }

  .btn-submit:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  .btn-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
</style>
